import React from 'react';
import PropTypes from 'prop-types';

import {styled} from "@mui/material/styles";

import {ImageSharp} from "@mui/icons-material";
import {greyishBlue100} from "assets/jss/main";

ListingProductImage.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
};

const imageFrame = {
    width: '84px',
    height: '112px',
    boxSizing: 'border-box',
    borderRadius: '8px',
    border: `1px solid ${greyishBlue100}`
};

const StyledImage = styled('img')({
    ...imageFrame,
    objectFit: 'cover',
    verticalAlign: 'middle'
});

const PlaceholderContainer = styled('div')({
    ...imageFrame,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle'
});

function ListingProductImage({src, alt = "product_image"}) {
    if (!src) {
        return (
            <PlaceholderContainer>
                <ImageSharp color={"disabled"} sx={{fontSize: '40px'}}/>
            </PlaceholderContainer>
        );
    }

    return <StyledImage src={src} alt={alt}/>;
}

export default ListingProductImage;
